module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "Reporting_Icon.b5f11b40.png";